import React,{useState} from "react";
import {useForm} from "react-hook-form";
import { toSeconds } from "../utils/utils";
import axiosInstance from "../services/axios";
import { useNavigate } from "react-router-dom";

// import axiosInstance from "../../../services/axios";

// import { toSeconds } from "../../../utils/utils";




function AdvanceDebate(){
    const navigate = useNavigate();
    const [formValues, setFormValues] = useState([{ action: "", is_voting_allow: "",section:"",hour:"",minutes:""}]);
    const [count,setCount] = useState(1);
    let handleChange = (i, e) => {
        let newFormValues = [...formValues];
        newFormValues[i][e.target.name] = e.target.value;
        setFormValues(newFormValues);
    }
    const {
        handleSubmit,
        register,
        formState: { errors, isSubmitting},
    }=useForm();
   
    const onSubmit = async(values)=>{
        const participants_code = Math.random().toString(36).slice(4);
        const audience_code =  Math.random().toString(36).slice(4);
        values.participants_code = participants_code;
        values.audience_code = audience_code;
        const advance_details=[];
        const topics = values.section;
        advance_details.push({"topics":[topics],"section_details":[]});
        // advance_details.push({"section_details":[]});        
        for(let i=0;i<count;i++){
            const hour = values.hour[i];
            const minutes = values.minutes[i];
            const total_time = toSeconds(hour,minutes)
            advance_details[0]["section_details"].push({"action":values.action[i],"is_voting_allow":values.is_voting_allow[i],"vote_type":values.vote_type[i],"section":values.section[i],"time":total_time})
        }
        values.advance_details = advance_details;

        delete values.section;
        delete values.vote_type;
        delete values.is_voting_allow;
        delete values.hour;
        delete values.minutes;
        delete values.action;
        try{
            await axiosInstance.post(`/create/`, values);
            navigate("/debates", { replace: true }); // <-- redirect

        }
        catch(err){
            throw(err)
        }
    };
    let addFormFields = () => {
        let field_count = count+1;
        setCount(field_count);
        setFormValues([...formValues, { action: "", is_voting_allow: "",section:"",hour:"",minutes:""}])
    }
    
    let removeFormFields = (i) => {
        let field_count = count-1;
        setCount(field_count);
        let newFormValues = [...formValues];
        newFormValues.splice(i, 1);
        setFormValues(newFormValues)
    }

    const updateTotalminute = (time_id)=>{
        var minute = document.getElementById(`minutes[${time_id}]`).value
        var total_min = document.getElementById("total_minutes")
        if(minute.toString() === ''){
            minute = 0
        }
        var t_min = parseInt(total_min.value)+parseInt(minute);
        if(t_min === 0){
            t_min="00"
        }
        if(t_min.toString().length<2){
            t_min="0"+t_min.toString()
        }
        total_min.value = t_min;


    }
    const updateTotalhour = (time_id)=>{
        var hour = document.getElementById(`hour[${time_id}]`).value
        var total_hour = document.getElementById("total_hour")
        console.log(hour,total_hour.value,"from total houe")
        // total_hour.value =  parseInt(total_hour.value)+parseInt(hour);
        // total_min.value = parseInt(total_min.value)+parseInt(minute);
        
        if(hour.toString()===''){
            hour = 0 
        }

        
        var t_hr = parseInt(total_hour.value)+parseInt(hour);
        // console.log(hour,t_min,total_min.value,minute.toString(),"from update")
        if(t_hr === 0){
            t_hr="00"
        }
       
        if(t_hr.toString().length<2){
            t_hr="0"+t_hr.toString()
        }
     
        total_hour.value =  t_hr;
    }
    return (
            <div>
            <form method="POST" className="advance" onSubmit={handleSubmit(onSubmit)}>
            <input type="hidden" name="type" value="advance" {...register("type")} />

                <div className="form-step-row-advance-first">
                        <div class="row">
                            <div class="col-sm">
                                <label htmlFor="debate_title_advance">Title of debate</label>
                                <input type="text" className="form-control" id="debate_title_advance" name="title" placeholder="Enter debate title"  {...register("title", {
                                    required: "This is required field",
                                })}/> 
                                {errors.title && <span className="error-message">Title is required &nbsp; </span>}
                                  
                            </div>
                            <div class="col-sm">
                                <label htmlFor="advance_debate_total_time">Total Time of Debate</label>
                                <div className="form-control time-input-div d-flex align-items-center" id="advance_debate_total_time">
                                    <input type="text"  min="0" max="23" placeholder="00" maxLength="2" name="total_hour" {...register("total_hour", {
                                    required: "This is required field",
                                })} />
                                    <span>hr</span>
                                    <input type="text"  min="0" max="59" placeholder="00" maxLength="2" name="total_minutes" {...register("total_minutes", {
                                    required: "This is required field",
                                })}/>
                                    <span>min</span>
                                    <img src={process.env.PUBLIC_URL+"img/timer-watch-icon-black.png"} className="icon" alt="" title="" width="16" style={{marginLeft:"50%"}} />
                                </div>
                            </div>
                            <div class="col-sm">
                                <label htmlFor="advance_members">No. of members on each side</label>
                                    <div className="radio-input mr-2">
                                        <input type="radio" id="advancemember1" name="members_each_side" value="1"  {...register("members_each_side")}/>
                                        <label htmlFor="advancemember1">1</label>
                                    </div>

                                    <div className="radio-input mr-2">
                                        <input type="radio" id="advancemember2" name="members_each_side" value="2" {...register("members_each_side")}/>
                                        <label htmlFor="advancemember2">2</label>
                                    </div>

                                    <div className="radio-input mr-2">
                                        <input type="radio" id="advancemember3" name="members_each_side" value="3" {...register("members_each_side")}/>
                                        <label htmlFor="advancemember3">3</label>
                                    </div>

                                    <div className="radio-input mr-2">
                                        <input type="radio" id="advancemember4" name="members_each_side" value="4" {...register("members_each_side")}/>
                                        <label htmlFor="advancemember4">4</label>
                                    </div>

                                    <div className="radio-input">
                                        <input type="radio" id="advancemember5" name="members_each_side"  value="5" {...register("members_each_side")}/>
                                        <label htmlFor="advancemember5">5</label>
                                    </div>

                            </div>


                        </div>
                </div>

                        
                <div className="form-step-row-advance-second">

                    <div className="row">
                        <div class="col-sm">
                            <label htmlFor="action">Action</label>
                            
                        </div>
                        <div class="col-sm">
                            <label htmlFor="is_voting_allow">Allow Voting</label>
                            
                        </div>
                        <div class="col-sm">
                            <label htmlFor="vote_type">Type of Voting</label>
                            
                        </div>
                        <div class="col-sm">
                        <label htmlFor="section">Section</label>
                        </div>
                        <div class="col-sm">
                        <label htmlFor="advance_section_time">Time</label>
                        </div>
                    </div>
                    {/* input fields for advance section */}
                    {formValues.map((element, index) => (
                    <div key={index} className="row">
                        <div className="col-sm">
                            <select className="form-control" id="action_advance" name={`action[${index}]`} onChange={e => handleChange(index, e)}   {...register(`action.${index}`, {
                                required: "This is required field",
                            })}>
                                    <option value="1">Left Side</option>
                                    <option value="2">Right Side</option>
                                    <option value="3">No speech</option>
                                    <option value="4">Break</option>
                            </select>
                        </div>
                        <div className="col-sm">
                        <select className="form-control" id="is_voting_allow" name={`is_voting_allow[${index}]`}  onChange={e => handleChange(index, e)}   {...register(`is_voting_allow.${index}`, {
                                required: "This is required field",
                            })}>
                                <option value="1">Allow</option>
                                <option value="0">Not Allow</option>                                    
                            </select>
                        </div>
                        <div className="col-sm">
                        <select class="form-control" id="vote_type_0" name={`vote_type[${index}]`}  {...register(`vote_type.${index}`, {
                                required: "This is required field",
                            })}>
                                <option value="1">Vote</option>                                   
                                <option value="0">Score</option>
                        </select>

                        </div>
                        <div className="col-sm">
                            <input type="text" className="form-control" id="section" name={`section[${index}]`} placeholder="Enter title"  onChange={e => handleChange(index, e)}  {...register(`section.${index}`, {
                                required: "This is required field",
                            })}/>
                        </div>
                        <div className="col-sm">
                            <div className="form-control time-input-div d-flex align-items-center" id="advance_section_time">
                                    <input type="text" id={`hour[${index}]`} min="0" max="23" placeholder="00" maxLength="2" name={`hour[${index}]`} onChange={e => handleChange(index, e)}  {...register(`hour.${index}`, {
                                required: "This is required field",
                            })} />
                                    <span>hr</span>
                                    <input type="text" id={`minutes[${index}]`} min="0" max="59" placeholder="00" maxLength="2"  name={`minutes[${index}]`}  onChange={e => handleChange(index, e)}  {...register(`minutes.${index}`, {
                                required: "This is required field",
                            })}/>
                                    <span>min</span>
                                    <img src={process.env.PUBLIC_URL+"img/timer-watch-icon-black.png"} className="icon" alt="" title="" width="16" style={{marginLeft:"40%"}}/>
                            </div>
                            {errors.hour && <span className="error-message">hour is required &nbsp; </span>}
                            {errors.minutes && <span className="error-message">minute is required </span>}


                            { index ? 
                            <span className="delete"onClick={() => removeFormFields(index)}>Delete</span>:""
                            }
                        </div>

                       
                        {/* { index ?
                        <div>
                            <a  style={{cursor: "pointer"}}  className="add-topic" >Remove</a>
                        </div>:
                        // <div>
                        // <a  style={{cursor: "pointer"}}  className="add-topic" onClick={() => removeFormFields(index)}>Remove</a>
                        // </div>
                        ""
                        } */}
                        

                    </div>
                    
                

                    
                    ))}
                
                <div className="row">
                    <div className="col-2">
                        <div className="form-group" >
                                <a style={{cursor: "pointer"}} className="add-topic" onClick={() => addFormFields()}>+ Add more</a>
                        </div>
                    </div>
                
                    

                </div>
                    
                        
                        
                </div>

                <div className="form-step-row last">
                    <div className="form-row-left">
                    </div>

                    <div className="form-row-right">
                        <input type="submit" className="btn btn-primary"  value="Finish" />
                    </div>
                </div>
                
            </form>
            </div>

    );
}

export default AdvanceDebate;